module.exports = __webpack_public_path__ + "img/Faderen_Bilde-av-diktet-Lokkeleg.2d4daf0b.jpg";